module.exports = __webpack_public_path__ + "img/5.536d5bf4.png";